import React from 'react';
import { AppContextProvider } from './components/contexts/AppContextProvider';
import { Routes } from './components/routing/Routes';
import {AccessLog} from "./components/logging/AccessLog";

function App() {
  return (
    <div className="App">
      <AppContextProvider>
        <AccessLog>
          <Routes />
        </AccessLog>
      </AppContextProvider>
    </div>
  );
}

export default App;
